var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'has-location': _vm.showLocation },attrs:{"id":"app"}},[(_vm.showLocation)?_c('header',{staticClass:"location-status"},[_vm._v("未获取定位")]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }